<template>
  <section v-if="pageLoader" class="test">
    <div class="info-block">Загрузка...</div>
  </section>
  <section v-else-if="!userIsEmpty('user')" class="test">
    <div class="section-header section-header-alt">
      <div class="container-mobile">
        <h1 class="heading">{{ testTitle }}</h1>
        <div v-if="!complete" class="test-progress">
          Вы ответили на {{ completeCount }}
          {{
            declineNouns(completeCount, ["вопрос", "вопроса", "вопросов"])
          }}
          из 1
        </div>
        <div v-else class="test-progress">Вы ответили на все вопросы</div>
      </div>
    </div>
    <div class="info-block container-mobile">
      <ul v-if="!complete" class="test-list">
        <li class="test-question">
          <div class="question-name">1. Вопрос первый</div>
          <div class="question-answers">
            <div
              v-for="(answer, key) in questions"
              class="question-answer-group"
              :key="key"
            >
              <input
                v-model="picked"
                type="radio"
                :id="'a' + key"
                name="question"
                :value="key"
                v-validate="'required'"
                @change="updateProgress"
                class="input-radio"
              />
              <label :for="'a' + key" class="radio-label">{{ answer }}</label>
            </div>

            <div class="v-error">{{ errors.first("question") }}</div>
          </div>
        </li>
      </ul>
      <div v-else class="test-result">
        <div
          :style="{
            'background-image': test.avatar ? 'url(' + test.avatar + ')' : '',
          }"
          class="test-result-avatar"
          :class="{ 'no-image': !test.avatar }"
        ></div>
        <div class="test-result-subtitle">Ваш результат</div>
        <div class="test-result-title">
          <span v-if="picked == 0">Интроверт</span>
          <span v-if="picked == 1">Экстраверт</span>
        </div>
        <div class="test-result-text">{{ result.result }}</div>
        <div @click="restart" class="test-again link">Пройти тест еще раз</div>
      </div>
    </div>
    <div v-if="!complete" class="buttons-row">
      <button @click="back" type="button" class="button-secondary">
        Отмена
      </button>
      <button @click="submit" v-if="!loader" class="button">Продолжить</button>
      <button v-if="loader" class="button button-loader"></button>
    </div>
    <div v-else class="buttons-row">
      <button @click="back" type="button" class="button-secondary">
        Вернуться к тестам
      </button>
      <button @click="share" v-if="!loader" class="button">
        Поделиться с друзьями
      </button>
      <button v-if="loader" class="button button-loader"></button>
    </div>
  </section>
  <section v-else class="no-auth">
    Вы не авторизованы! Пожалуйста,
    <router-link class="link" tag="a" :to="{ name: 'home' }"
      >войдите или зарегистрируйтесь</router-link
    >
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { declineNouns } from "@/mixins/declineNouns";

export default {
  name: "Test",
  mixins: [localizeValidation, declineNouns],
  data() {
    return {
      id: "",
      test: {},
      completeCount: 0,
      complete: false,
      progress: [],
      loader: false,
      picked: "",
      pageLoader: true,
    };
  },
  computed: {
    ...mapGetters({
      userIsEmpty: "user/isEmpty",
      user: "user/fetchUser",
      userErrors: "user/errors",
      questions: "tests/fetchQuestions",
      testTitle: "tests/fetchTestTitle",
      result: "tests/fetchTestResult",
    }),
  },
  created() {
    this.localizeValidation();
    this.id = this.$route.params.id;
    this.getQuestions();
  },
  methods: {
    getQuestions() {
      this.$store
        .dispatch("tests/pass", this.id)
        .then(() => {
          this.pageLoader = false;
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },
    updateProgress() {
      this.completeCount = 1;
    },
    submit() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loader = true;
          this.$store
            .dispatch("tests/result", {
              id: this.id,
              data: {
                answer: this.picked,
              },
            })
            .then(() => {
              this.complete = true;
              this.loader = false;
            })
            .catch(() => {
              this.complete = true;
              this.loader = false;
            });
        }
      });
    },
    back() {
      this.$router.push({ name: "tests" });
    },
    share() {
      this.loader = true;
      this.$store
        .dispatch("tests/share", {
          id: this.id,
          data: this.result,
        })
        .then(() => {
          this.loader = false;
          this.$modal.show("dialog", {
            title: "Успех!",
            text: "Результаты теста появятся в событиях ваших друзей.",
            buttons: [
              {
                title: "ОК",
              },
            ],
          });
        })
        .catch(() => {
          this.loader = false;
        });
    },
    restart() {
      this.picked = "";
      this.completeCount = 0;
      this.complete = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/pages/_test";
</style>
